import { Module } from '../Module';
import { _submitForm } from './functions/_submitForm';
// import { _slider } from './functions/_slider';
// import { _variantSelector } from './functions/_variantSelector';

/**
 * Module for product.
 *
 */
export class Product extends Module {
	initialize() {
		_submitForm();
		// _slider();
		// _variantSelector();
		// _optionSelector();
	}
}
